/**
 * Returns the heading tag one level below the given one, or undefined when the
 * input is not a heading tag.
 */
export function calculateHeadingChildren (parentHeadingTag: string) {
  const headingLevel = parseInt(parentHeadingTag.match(/h(\d)/)?.[1] ?? '', 10);
  if (headingLevel) {
    return `h${headingLevel + 1}`;
  }
}
